import type { BookingId, Currency } from "../../../../../../../types/primitiveTypes"
import { transport } from "../../../../../../../services/api/transport"
import { FETCH_SERVICE_PACKAGE_RULES } from "../consts"
import mapperServicePackageRuleset from "./mapperServicePackageRuleset"

export const fetchServicePackageRulesetAction = (bid: BookingId, currency: Currency) => {
  const promise = transport(
    "GET",
    bid,
    `/mmb/v1/bookings/${bid}/service_package_rules?currency=${currency.toUpperCase()}`,
    null,
    null,
    3,
  ).then(mapperServicePackageRuleset)

  return {
    type: FETCH_SERVICE_PACKAGE_RULES,
    promise,
  }
}
